<template>
  <component :is="ShippingAndReturnsPerksComponent" />
</template>

<script setup>
/* istanbul ignore file */
import { defineAsyncComponent } from 'vue';
import { useEnvProps } from '~/composables/useEnvProps';

const { brand } = useEnvProps();
const ShippingAndReturnsPerksComponent = defineAsyncComponent(() => import(`./ShippingAndReturnsPerks.${brand}.vue`));
</script>
